/** Arrange supporting controls without changing their existing handlers. */
export function setupConciseLayout(root) {
  const stack = document.createElement('aside');
  stack.className = 'map-audio-stack';
  stack.setAttribute('aria-label', 'World map and narration');
  for (const id of ['world-map']) {
    const element = root.querySelector('#' + id);
    if (element) stack.append(element);
  }
  root.append(stack);
  // Keep walking and graphics settings beside the existing audio settings.
  root.querySelector('#voice-menu').append(root.querySelector('#navigation-mode'));
}
